import { useState } from 'react';
import OrderService from './OrderService';
import { useSelector } from 'react-redux';
import { RsvpOutlined } from '@mui/icons-material';

function useManageOrder() {

  const [orderGroup, setOrderGroup] = useState([]);
  const [orders, setOrders] = useState([])
  const [totalOrderCount, setTotalOrderCount] = useState(0)
  const [orderSummary, setOrderSummary] = useState([])
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const shopName = useSelector((state) => state.shop.name);
  

  const addNewOrder = async (formData) => {
    let result = true;
    setIsLoading(true);
    try {
      // Add shop to FormData
      formData.append('shop', shopName);
      const response = await OrderService.addNewOrder(formData);
      const data = response.data;
      const ok = data === "Success" || data?.message === "Success";
      if (!ok) {
        setError(data?.message || 'Failed to create order');
        result = false;
      } else {
        result = { ok: true, ordererMatch: data?.ordererMatch ?? null, orderId: data?.orderId ?? null };
      }
    } catch (err) {
      result = false;
      console.log(err)
      setError(err.response && err.response.data && err.response.data.message
               ? err.response.data.message
               : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const addSendOnlyNewOrder = async (payload) => {
    let result = true;
    setIsLoading(true);
    try {
      const updatedFormData = {...payload, shop: shopName}
        const response = await OrderService.addSendOnlyNewOrder(updatedFormData);
        if (response.data !== "Success") {
            setError(response.data.message);
            result = false;
        }
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                 ? err.response.data.message 
                 : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
    return result;
  };

  const getPendingOrder = async () => {
    let result = true;
    try {
      const response = await OrderService.getPendingOrder(shopName);
      console.log(response.data)
      setOrderGroup(response.data)
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
  }

  const getOrderUrl = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName }
      const response = await OrderService.getOrderUrl(updatedFormData);
      console.log(response.data)
      return response.data
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
        return false
    } finally {
        setIsLoading(false);
    }
  }

  const getArrivalAcceptLists = async () => {
    let result = true;
    try {
      const response = await OrderService.getArrivalAcceptLists();
      console.log(response.data)
      setOrders(response.data)
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
  }

  const getOrderLogs = async (orderId) => {
    let result
    try {
      const response = await OrderService.getOrderLogs({orderId});
      console.log(response.data)
      return response.data
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
  }

  const getLatestOrder = async (formData) => {
    let result = true;
    setIsLoading(true);
    try {
      const updatedFormData = { ...formData, shop: shopName }
      const response = await OrderService.getLatestOrder(updatedFormData);
      const data = response.data;
      if (data && data.rows !== undefined) {
        setOrders(data.rows)
        const cnt = typeof data.count === 'number' ? data.count : Array.isArray(data.count) ? data.count.length : 0
        setTotalOrderCount(cnt)
        return data.rows
      }
      setOrders(Array.isArray(data) ? data : [])
      return data
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
        return false
    } finally {
        setIsLoading(false);
    }
  }

  const getOrdersFromSmileName = async (formData) => {
    let result = true;
    try {
      setIsLoading(true)
      const updatedFormData = { ...formData, shop: shopName }
      const response = await OrderService.getOrdersFromSmileName(updatedFormData);
      console.log(response.data)
      setOrders(response.data)
      setIsLoading(false)
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
        setIsLoading(false)
    } finally {
        setIsLoading(false);
    }
  }

  const getOrderForWeeklyShipMatch = async () => {
    let result = true;
    try {
      const response = await OrderService.getOrderForWeeklyShipMatch();
      console.log(response.data)
      setOrderGroup(response.data)
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
  }

  const updateOrder = async (order, userId) => {
    let result = true;
    try {
      const updatedOrder = { ...order, shop: shopName };
      const response = await OrderService.updateOrder(updatedOrder, userId);
      console.log(response.data)
      
      return result
    } catch (err) {
      console.log(err.response.data.message)
        result = err.response.data.message;
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'ไม่พบข้อมูล');
    } finally {
        setIsLoading(false);
    }
    return result
  }

  const updateOrderStatus = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName };
      await OrderService.updateOrderStatus(updatedFormData);
      return result
    } catch (err) {
        result = false;
        console.log(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
  }

  const arrivalAccept = async (formData) => {
    let result = true;
    try {
      await OrderService.arrivalAccept(formData);
    } catch (err) {
        result = false;
        console.log(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
        return result
    }
  }

  const getNoTrackingOrder = async (tabName) => {
    let result = true;
    try {
      const response = await OrderService.getNoTrackingOrder({shop: shopName, tabId: tabName});
      console.log(response.data)
      setOrderGroup(response.data)
    } catch (err) {
        result = false;
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
  }

  const getAllProcessOrders = async () => {
    try {
      setIsLoading(true)
      const response = await OrderService.getAllProcessOrders({shop: shopName});
      return response.data
    } catch (err) {
        setIsLoading(false)
        console.log(err)
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
        return false
    } finally {
        setIsLoading(false);
    }
  }

  const getNoDeliveryFeeOrder = async (shipDateId) => {
    let result = true;
    try {
      const updatedFormData = { ...{shipDateId, shop: shopName}}
      const response = await OrderService.getNoDeliveryFeeOrder(updatedFormData);
      setOrders(response.data)
    } catch (err) {
        result = false;
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
  }

  const getOrderSummary = async (formData, append = false) => {
    let result = true;
    try {
      const response = await OrderService.getOrderSummary(formData);
      if (append && orders && orders.length > 0) {
        // Append new orders to existing ones
        setOrders([...orders, ...(response.data.orders || response.data)])
        // Preserve existing summary when loading more (summary is calculated from all orders on first load)
        // Only update summary if it's provided and we don't have one yet
        if (response.data.summary && !orderSummary) {
          setOrderSummary(response.data.summary)
        }
      } else {
        // Replace orders (initial load or new search)
        setOrders(response.data.orders || response.data)
        // Update summary on initial load
        setOrderSummary(response.data.summary)
      }
      console.log(response.data.summary)
      setError('')
      return {
        success: true,
        hasMore: response.data.hasMore,
        totalCount: response.data.totalCount
      }
    } catch (err) {
        result = false;
        if (!append) {
          setOrders([])
          setOrderSummary(null)
        }
        setError(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'ไม่พบข้อมูล');
        return {
          success: false,
          hasMore: false,
          totalCount: 0
        }
    } finally {
        setIsLoading(false);
    }
  }

  const updateTrackingJp = async (order, userId, mercariImage = null) => {
    try {
      const updatedOrder = {...order, shop:shopName}
      await OrderService.updateTrackingJp(updatedOrder, userId, mercariImage);
      return { success: true }
    } catch (err) {
      console.log(err)
      const errorMessage = err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : (err.response && err.response.data && err.response.data.error
                  ? err.response.data.error
                  : 'An error occurred.');
      setError(errorMessage);
      return { success: false, message: errorMessage }
    } finally {
        setIsLoading(false);
    }
  }

  const updateProcessOrder = async (uuid) => {
    try {
      console.log('updateProcessOrder')
      await OrderService.updateProcessOrder(uuid);
      return true
    } catch (err) {
      console.log(err)
        console.log(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
      return false
    } finally {
        setIsLoading(false);
    }
  }

  const collectInformCustomer = async (formData) => {
    try {
      await OrderService.collectInformCustomer(formData);
      return true
    } catch (err) {
      console.log(err)
      console.log(err.response && err.response.data && err.response.data.message 
              ? err.response.data.message 
              : 'An error occurred.');
      return false
    } finally {
        setIsLoading(false);
    }
  }

  const updateByLinkAndSmile = async (formData) => {
    let result = true;
    try {
      await OrderService.updateByLinkAndSmile(formData);
      return result
    } catch (err) {
        result = false;
        console.log(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.');
    } finally {
        setIsLoading(false);
    }
  }

  const updateOrderAndUploadReceipt = async (formData) => {
    let result = true;
    try {
      formData.append('shop', shopName); // Append shop to FormData
      await OrderService.updateOrderAndUploadReceipt(formData);
      return result
    } catch (err) {
        result = false;
        // err.response is undefined on a network failure, and some backend 400s only
        // set `message` — falling through all of them keeps the real reason visible
        // instead of crashing this catch (which left callers' loading state stuck).
        const errorMessage = err.response?.data?.error || err.response?.data?.message || err.message || 'เกิดข้อผิดพลาดในการอัพเดทข้อมูล';
        console.log(errorMessage)
        setError(errorMessage)
      return errorMessage
    } finally {
        setIsLoading(false);
    }
}


  const getAmountFromUrl = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName };
      const response = await OrderService.getAmountFromUrl(updatedFormData);
      result = response.data
      return result
    } catch (err) {
        /* console.log(err.response && err.response.data && err.response.data.message 
                ? err.response.data.message 
                : 'An error occurred.'); */
        console.log(err)
        // Rethrow: swallowing this returned undefined to the caller, which then
        // destructured it and showed "Cannot destructure property 'totalSum'"
        // instead of the real backend message (e.g. "Customer not found").
        throw err
    } finally {
        setIsLoading(false);
    }
  }

  const deleteOrder = async (orderId) => {
    setIsLoading(true);
    let result = true
    try {
        const updatedFormData = {...{orderId}, shop: shopName}
        await OrderService.deleteOrder(updatedFormData);
    } catch (err) {
      result = false
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
        return result
    }
};

  const massUpdate = async (formData, userId) => {
    setIsLoading(true);
    let result = true
    try {
      const updatedFormData = { ...formData, shop: shopName }
      console.log(updatedFormData)
      await OrderService.massUpdate(updatedFormData, userId);
    } catch (err) {
      result = false
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
        return result
    }
};

  const getBlacklistItems = async (customerId) => { //Fix Shop
    setIsLoading(true);
    let result = true
    try {
        const response = await OrderService.getBlacklistItems(customerId);
        result = response.data
    } catch (err) {
      result = false
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
        return result
    }
};

  const getOrdersWithoutPurchaseConfirm = async () => {
    let result = true;
    setIsLoading(true);
    try {
      const response = await OrderService.getOrdersWithoutPurchaseConfirm(shopName);
      setOrders(response.data.rows || response.data);
      return response.data;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
               ? err.response.data.message 
               : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const uploadPurchaseConfirmImage = async (orderId, imageFile) => {
    let result = true;
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('orderId', orderId);
      formData.append('images', imageFile);
      
      const response = await OrderService.uploadPurchaseConfirmImage(formData);
      
      if (response.data.success) {
        return response.data;
      } else {
        setError(response.data.message || 'Upload failed');
        result = false;
      }
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
               ? err.response.data.message 
               : 'An error occurred during upload.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const getMercariOrderList = async (formData) => {
    setIsLoading(true);
    try {
      const response = await OrderService.getMercariOrderList(formData);
      // Return the entire response object to access metadata
      return response.data;
    } catch (err) {
      console.log(err);
      const errorMessage = err.response && err.response.data && err.response.data.message 
               ? err.response.data.message 
               : 'An error occurred.';
      setError(errorMessage);
      // Return an object with success: false so the component can handle it properly
      return {
        success: false,
        message: errorMessage,
        data: []
      };
    } finally {
      setIsLoading(false);
    }
  };

  const markMercariOrderReceived = async (orderId) => {
    let result = true;
    setIsLoading(true);
    try {
      const response = await OrderService.markMercariOrderReceived(orderId);
      if (!response.data.success) {
        setError(response.data.message);
        result = false;
      }
    } catch (err) {
      result = false;
      console.log(err)
      setError(err.response && err.response.data && err.response.data.message 
               ? err.response.data.message 
               : 'Failed to mark order as received');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const addMercariCheckRecord = async (formData) => {
    let result = true;
    try {
      const response = await OrderService.addMercariCheckRecord(formData);
      // Check for the correct response format
      if (!response.data.success) {
        setError(response.data.message || 'Failed to add check record');
        result = false;
      }
    } catch (err) {
      result = false;
      console.log(err)
      setError(err.response && err.response.data && err.response.data.message 
               ? err.response.data.message 
               : 'Failed to add check record');
    }
    return result;
  };

  const createFirstOrderPaymentLink = async (formData, shopOverride) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopOverride ?? shopName };
      const response = await OrderService.createFirstOrderPaymentLink(updatedFormData);
      result = response.data;
      return result;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
            ? err.response.data.message 
            : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const checkExistingPaymentLink = async (formData, shopOverride) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopOverride ?? shopName };
      const response = await OrderService.checkExistingPaymentLink(updatedFormData);
      result = response.data.data;
      console.log(result)
      return result;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
            ? err.response.data.message 
            : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const createSecondOrderPaymentLink = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName };
      const response = await OrderService.createSecondOrderPaymentLink(updatedFormData);
      console.log(response)
      result = response.data;
      return result;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
          ? err.response.data.message 
          : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const getOrderSummaryByUrls = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName };
      const response = await OrderService.getOrderSummaryByUrls(updatedFormData);
      setOrders(response.data.orders || []);
      setOrderSummary(response.data.summary || {});
      console.log(response.data)
      return result;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
          ? err.response.data.message 
          : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const getPaymentIntentSummary = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName };
      console.log(updatedFormData)
      const response = await OrderService.getPaymentIntentSummary(updatedFormData);
      console.log('Raw response:', response.data);
      result = response.data.data; // Return the entire response.data
      return result;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
            ? err.response.data.message 
            : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const createNonCompanySummaryCode = async (formData) => {
    try {
      const updatedFormData = { ...formData, shop: shopName };
      const response = await OrderService.createNonCompanySummaryCode(updatedFormData);
      return response.data.data;
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred.');
      return null;
    }
  };

  const getSummaryByCode = async (code) => {
    try {
      const response = await OrderService.getSummaryByCode(code, shopName);
      return response.data.data;
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred.');
      return null;
    }
  };

  const getOrdersBySmileNameAndUrls = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName };
      const response = await OrderService.getOrdersBySmileNameAndUrls(updatedFormData);
      result = response.data;
      return result;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
          ? err.response.data.message 
          : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const createPrePaymentLink = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName };
      const response = await OrderService.createPrePaymentLink(updatedFormData);
      result = response.data;
      return result;
    } catch (err) {
      result = err;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
          ? err.response.data.message 
          : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const updateOrderImageAndConfirm = async (formData) => {
    let result = true;
    setIsLoading(true);
    try {
      formData.append('shop', shopName);
      const response = await OrderService.updateOrderImageAndConfirm(formData);
      if (response?.data?.success) {
        result = { ok: true, ordererMatch: response.data.ordererMatch ?? null };
      }
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message
               ? err.response.data.message
               : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const getPendingBeamBeforePurchases = async () => {
    let result = true;
    setIsLoading(true);
    try {
      const response = await OrderService.getPendingBeamBeforePurchases({ shop: shopName });
      setOrders(response.data);
      console.log(response.data)
      return response.data;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
               ? err.response.data.message 
               : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const cancelPendingBeamBeforePurchases = async (orderId) => {
    let result = true;
    setIsLoading(true);
    try {
      const response = await OrderService.cancelPendingBeamBeforePurchases(orderId);
      console.log(response.data);
      return response.data;
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
               ? err.response.data.message 
               : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const cancelOrder = async (formData) => {
    let result = true;
    try {
      const updatedFormData = { ...formData, shop: shopName };
      await OrderService.cancelOrder(updatedFormData);
      return result;
    } catch (err) {
      result = false;
      console.log(err.response && err.response.data && err.response.data.message 
              ? err.response.data.message 
              : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const getCancelledOrders = async () => {
    let result = true;
    try {
      const response = await OrderService.getCancelledOrders({ shop: shopName });
      setOrderGroup(response.data);
    } catch (err) {
      result = false;
      console.log(err);
      setError(err.response && err.response.data && err.response.data.message 
              ? err.response.data.message 
              : 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const processCancellation = async (payload) => {
    let result = true;
    try {
      const formData = new FormData();
      formData.append('orderId', payload.orderId);
      formData.append('action', payload.action);
      formData.append('shop', shopName);
      formData.append('adminId', payload.adminId ?? '');
      if (payload.note != null && String(payload.note).trim() !== '') {
        formData.append('note', String(payload.note).trim());
      }
      if (payload.receiptFile && payload.receiptFile instanceof File) {
        formData.append('images', payload.receiptFile);
      }
      await OrderService.processCancellation(formData);
      return result;
    } catch (err) {
      result = false;
      const msg = err.response?.data?.message || err.response?.data?.error || 'An error occurred.';
      setError(msg);
      throw new Error(msg);
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  // Gain/North resolve a credit-card void-check: 'voided' (closed) or 'reject' (→ refund).
  const resolveVoidCheck = async (orderId, action) => {
    try {
      await OrderService.resolveVoidCheck(orderId, action);
      return true;
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred.');
      return false;
    }
  };

  // Claim a customer's cancellation case so only one admin processes it. Returns
  // { ok, message } — message is the server's "taken by X" on 409.
  const claimCancelCase = async (customerId, takeover = false) => {
    try {
      await OrderService.claimCancelCase({ customerId, shop: shopName, takeover });
      await getCancelledOrders();
      return { ok: true };
    } catch (err) {
      return { ok: false, message: err.response?.data?.message || 'รับเคสไม่สำเร็จ' };
    }
  };

  const releaseCancelCase = async (customerId) => {
    try {
      await OrderService.releaseCancelCase({ customerId, shop: shopName });
      await getCancelledOrders();
    } catch (err) { /* release is best-effort */ }
  };

  return {
    error,
    orderGroup,
    orders,
    claimCancelCase,
    releaseCancelCase,
    orderSummary,
    isLoading,
    setOrders,
    getOrderLogs,
    addNewOrder,
    getPendingOrder,
    getNoTrackingOrder,
    getNoDeliveryFeeOrder,
    addSendOnlyNewOrder,
    updateOrder,
    getOrderSummary,
    updateTrackingJp,
    getOrderForWeeklyShipMatch,
    getOrdersFromSmileName,
    getAmountFromUrl,
    updateByLinkAndSmile,
    updateOrderAndUploadReceipt,
    getLatestOrder,
    totalOrderCount,
    deleteOrder,
    collectInformCustomer,
    massUpdate,
    getAllProcessOrders,
    updateProcessOrder,
    getArrivalAcceptLists,
    arrivalAccept,
    getBlacklistItems,
    getOrderUrl,
    updateOrderStatus,
    getOrdersWithoutPurchaseConfirm,
    uploadPurchaseConfirmImage,
    getMercariOrderList,
    markMercariOrderReceived,
    addMercariCheckRecord,
    createFirstOrderPaymentLink,
    checkExistingPaymentLink,
    createSecondOrderPaymentLink,
    getOrderSummaryByUrls,
    getPaymentIntentSummary,
    getOrdersBySmileNameAndUrls,
    createNonCompanySummaryCode,
    getSummaryByCode,
    createPrePaymentLink,
    updateOrderImageAndConfirm,
    getPendingBeamBeforePurchases,
    cancelPendingBeamBeforePurchases,
    cancelOrder,
    getCancelledOrders,
    processCancellation,
    resolveVoidCheck
  };
}

export default useManageOrder;
